var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.visible ? '' : 'xb-hiden-video',style:({
      height: _vm.videoHeight,
      width: _vm.videoWidth,
      position: 'relative',
    })},[((_vm.show_poster && _vm.poster && _vm.visible) || _vm.type == 'image')?_c('img',{staticClass:"xb-video-poster",attrs:{"src":_vm.type == 'image' ? _vm.preImage : _vm.poster}}):_vm._e(),_c('div',{ref:"wrapper",style:({
        height: _vm.videoHeight,
        width: _vm.videoWidth,
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }